import './AnnouncementsList.scss';

import { mdiInformationOutline } from '@mdi/js';
import type { AnnouncementToRender } from 'common/models';
import Icon from 'components/Icon/Icon';
import React from 'react';

interface Props {
  announcements: AnnouncementToRender[];
}

const AnnouncementsList: React.FC<Props> = (props): React.ReactElement => {
  const { announcements } = props;

  return (
    <div className="AnnouncementsList">
      {announcements.map((announcement) => (
        <div key={announcement.id} className={`AnnouncementsList_item ${announcement.type}`}>
          <div className="AnnouncementsList_icon">
            <Icon path={mdiInformationOutline} />
          </div>
          <div className="AnnouncementsList_content">
            <div className="AnnouncementsList_item-title">{announcement.title}</div>
            {announcement.description && (
              <div className="AnnouncementsList_item-description">{announcement.description}</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AnnouncementsList;
